const comparePrice = (item1, item2) => {
  if (item1.price === item2.price) {
    return [item1, item2];
  }
  return item1.price < item2.price ? [item1] : [item2];
};

module.exports = comparePrice;
